import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import InterestedParties from './InterestedParties';

const mapStateToProps = () => ({});

const mapDispatchToProps = {};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InterestedParties));
